import api from './config';

// Type definition for TikTok Comment
export interface TikTokComment {
  id: number;
  cid: number;
  video_id: string;
  video_web_url: string;
  text: string;
  digg_count: number;
  reply_comment_total: number;
  created_at: string;
  user_id: string;
  unique_id: string;
  avatar_thumbnail: string;
  is_replied: boolean;
  suggested_reply: string | null;
  priority: number;
  sentiment: string | null;
  category: string | null;
  brand_id: string | null;
  created_at_system: string;
  updated_at: string;
}

// Response type for paginated results
export interface TikTokCommentsResponse {
  data: TikTokComment[];
  total: number;
  page: number;
  limit: number;
}

// Filter options type
export interface TikTokCommentFilters {
  priority?: number;
  sentiment?: string;
  category?: string;
  is_replied?: boolean;
  brand_id?: string;
  video_id?: string;
  search?: string;
  page?: number;
  limit?: number;
}

// Get the list of TikTok comments with filtering and pagination
export const getTikTokComments = async (filters: TikTokCommentFilters = {}): Promise<TikTokCommentsResponse> => {
  const response = await api.get('/tiktok-comments', { params: filters });
  return response.data;
};

// Get filter options for TikTok comments (categories, sentiments, priorities, brands)
export const getTikTokCommentFilterOptions = async () => {
  const response = await api.get('/tiktok-comments/filter-options');
  return response.data;
};

// Update a TikTok comment (priority, sentiment, category, suggested_reply, is_replied)
export const updateTikTokComment = async (id: number, data: Partial<TikTokComment>) => {
  const response = await api.patch(`/tiktok-comments/${id}`, data);
  return response.data;
};

// Mark a comment as replied
export const markTikTokCommentAsReplied = async (id: number, isReplied: boolean) => {
  const response = await api.patch(`/tiktok-comments/${id}/reply-status`, { is_replied: isReplied });
  return response.data;
};

// Get statistics for TikTok comments
export const getTikTokCommentStats = async (filters: Partial<TikTokCommentFilters> = {}) => {
  const response = await api.get('/tiktok-comments/stats', { params: filters });
  return response.data;
}; 